import type { ReactElement } from 'react';

import type { CatalogItem } from '@/lib/quality-catalogs';

import type { ExtraFilter, UiFilters } from '../use-url-filters';
import type { FilterCatalogs } from './FilterBar';

// Filtros activos de la Lista Maestra como chips removibles (so=430; mockup 02). Tipo
// y proceso muestran el nombre del catálogo; sin catálogo no se muestra el id crudo.

const CLEAR_LABEL: Readonly<Record<ExtraFilter, string>> = {
  norm: 'Quitar el filtro de norma',
  clause: 'Quitar el filtro de cláusula',
  type: 'Quitar el filtro de tipo',
  area: 'Quitar el filtro de proceso',
};

function nameOf(
  items: CatalogItem[] | undefined,
  id: string,
  prefix: string,
  fallback: string,
): string {
  const item = items?.find((i) => i.id === id);
  return item ? `${prefix}: ${item.name}` : fallback;
}

function Chip(props: {
  text: string;
  filter: ExtraFilter;
  onClear: (f: ExtraFilter) => void;
}): ReactElement {
  return (
    <span className="chipf on">
      {props.text}
      <button
        type="button"
        className="chip-x"
        onClick={() => props.onClear(props.filter)}
        aria-label={CLEAR_LABEL[props.filter]}
      >
        ✕
      </button>
    </span>
  );
}

interface Props {
  filters: UiFilters;
  catalogs: FilterCatalogs | null;
  onClear: (f: ExtraFilter) => void;
}

export function ActiveFilterChips({ filters, catalogs, onClear }: Props): ReactElement {
  return (
    <>
      {filters.norm && <Chip text={`Norma: ${filters.norm}`} filter="norm" onClear={onClear} />}
      {filters.norm && filters.clause && (
        <Chip text={`Cláusula: ${filters.clause}`} filter="clause" onClear={onClear} />
      )}
      {filters.type && (
        <Chip
          text={nameOf(catalogs?.types, filters.type, 'Tipo', 'Tipo seleccionado')}
          filter="type"
          onClear={onClear}
        />
      )}
      {filters.area && (
        <Chip
          text={nameOf(catalogs?.areas, filters.area, 'Proceso', 'Proceso seleccionado')}
          filter="area"
          onClear={onClear}
        />
      )}
    </>
  );
}
